import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'antd';
import { ProConfigProvider } from '@ant-design/pro-components';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ProConfigProvider hashed={false}>
      <ConfigProvider theme={{ components: { Layout: { headerBg: "#1677FF",headerHeight:48 } }, token: { colorPrimary: '#1677FF' } }}>
        <App />
      </ConfigProvider>
    </ProConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
